const cleanStyles = {
  onTagAttr: (tag, name, value) => { // eslint-disable-line consistent-return
    if (name === 'style' || name === 'class' || name === 'href' || name === 'data-popupid' || name === 'title' || name === 'data-link-type') {
      return `${name}="${value}"`;
    }
  },
};

export default cleanStyles;
